import { Card, CardHeader, CardContent } from "@/components/ui/card";
import BreadcrumbComponent from "@/components/BreadcrumbComponent";
import { Coins, Star, Wallet } from "lucide-react";
import CardSkeleton from "@/components/CardSkeleton";
import { useBonuses } from "@/hooks/useBonuses";
import { useDeposits } from "@/hooks/useDeposits";
import { Typography } from "@/components/ui/typography";

const Bonuses = () => {
  const { bonusesData, isLoading } = useBonuses();
  const { depositsData, isLoading: isDepositsLoading } = useDeposits();

  return (
    <div className="flex w-full flex-col p-3">
      <BreadcrumbComponent link={"Бонусный счёт"} />
      <div className="mb-6 flex items-center gap-2">
        <Star className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-medium text-gray-900">Бонусный счёт</h2>
      </div>
      <div className="m:grid-cols-1 grid gap-4">
        {isLoading
          ? [...Array(1)].map((_, index) => <CardSkeleton key={index} />)
          : bonusesData &&
            bonusesData.map(
              (bonuses, index) =>
                (index === 0 || bonuses.balance > 0) && (
                  <Card key={bonuses.id} className="overflow-hidden transition-all hover:shadow-lg">
                    <CardHeader className="border-b bg-muted/50 p-4">
                      <div className="flex flex-col gap-2">
                        <div className="group flex items-center gap-3">
                          <div className="rounded-full bg-primary/10 p-2 sm:p-2">
                            <Coins className="h-5 w-5 text-primary" />
                          </div>
                          <Typography
                            variant="h3"
                            className="min-w-[40rem] text-lg font-normal text-gray-800 transition-colors group-hover:text-primary md:min-w-[20rem]"
                          >
                            {bonuses.name}
                          </Typography>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent className="space-y-4 p-4">
                      <div className="flex flex-col gap-3">
                        <div className="flex items-center justify-between text-sm">
                          <span className="text-muted-foreground">Баланс: </span>
                          <Typography variant="p" className="text-base leading-relaxed">
                            {bonuses.balance}
                          </Typography>
                        </div>
                        {/* Сроки действия бонусов(временно скрыли)
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-muted-foreground">Сроки действия: </span>
                      <Typography variant="p" className="text-base leading-relaxed">
                        {formatDateWithYear(bonuses.accrual_validity_period)}
                      </Typography>
                    </div> */}
                      </div>
                    </CardContent>
                  </Card>
                )
            )}
      </div>

      {/* Deposits Section */}
      <div className="mb-6 mt-8 flex items-center gap-2">
        <Wallet className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-medium text-gray-900">Лицевые счета</h2>
      </div>
      <div className="m:grid-cols-1 grid gap-4">
        {isDepositsLoading
          ? [...Array(1)].map((_, index) => <CardSkeleton key={index} />)
          : depositsData &&
            depositsData.map(
              (deposit, index) =>
                (index === 0 || deposit.balance > 0) && (
                  <Card key={deposit.id} className="overflow-hidden transition-all hover:shadow-lg">
                    <CardHeader className="border-b bg-muted/50 p-4">
                      <div className="flex flex-col gap-2">
                        <div className="group flex items-center gap-3">
                          <div className="rounded-full bg-primary/10 p-2 sm:p-2">
                            <Wallet className="h-5 w-5 text-primary" />
                          </div>
                          <Typography
                            variant="h3"
                            className="min-w-[40rem] text-lg font-normal text-gray-800 transition-colors group-hover:text-primary md:min-w-[20rem]"
                          >
                            {deposit.name}
                          </Typography>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent className="space-y-4 p-4">
                      <div className="flex flex-col gap-3">
                        <div className="flex items-center justify-between text-sm">
                          <span className="text-muted-foreground">Баланс: </span>
                          <Typography variant="p" className="text-base leading-relaxed">
                            {deposit.balance}
                          </Typography>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                )
            )}
      </div>
    </div>
  );
};

export default Bonuses;
